module.exports = __webpack_public_path__ + "img/badge_corsi.1fc081d9.jpg";